import Vue from 'vue';
import store from '../../store';
import recipeProcedureTransformer from '../../transformers/recipeProcedure';

const success = ({ data }, resolve) => {
  const recipeProcedures = recipeProcedureTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllRecipeProcedures', recipeProcedures);
  resolve(recipeProcedures);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/recipe_procedure')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeProcedure/all.js